import { render, staticRenderFns } from "./SurveyTypesList.vue?vue&type=template&id=70c487e2&scoped=true&"
import script from "./SurveyTypesList.vue?vue&type=script&lang=js&"
export * from "./SurveyTypesList.vue?vue&type=script&lang=js&"
import style0 from "./SurveyTypesList.vue?vue&type=style&index=0&id=70c487e2&lang=scss&scoped=true&"
import style1 from "./SurveyTypesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c487e2",
  null
  
)

export default component.exports